import { useTranslation as useI18nTranslation } from 'react-i18next';
import { useCallback } from 'react';

/**
 * Custom hook for translations with type safety
 * Ensures all translation keys are properly typed
 */
export function useTranslation() {
  const { t, i18n } = useI18nTranslation();

  /**
   * Translate a key with optional parameters
   * @param key - Translation key (supports nested keys with dot notation)
   * @param params - Optional parameters for interpolation
   */
  const translate = useCallback((key: string, params?: Record<string, string | number>) => {
    return t(key, params);
  }, [t]);

  /**
   * Get current language
   */
  const currentLanguage = i18n.language;

  /**
   * Change language - memoized to prevent infinite loops in useEffect
   */
  const changeLanguage = useCallback((lng: string) => {
    return i18n.changeLanguage(lng);
  }, [i18n]);

  /**
   * Check if language is RTL
   */
  const isRTL = i18n.dir() === 'rtl';

  return {
    t: translate,
    i18n,
    currentLanguage,
    changeLanguage,
    isRTL,
  };
}

